import React, { useState, useEffect } from "react";
import { StyledPageTitle, BackButton } from "./index.styled";
import { ChevronRight } from "lucide-react";
import logo from "../../../assets/images/logo-twist.png";

interface PageTitleProps {
  title: string;
  onBack?: () => void;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, onBack }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const formatTitle = (title: string) => {
    if (isMobile && title.includes(" ")) {
      const words = title.split(" ");
      const midPoint = Math.ceil(words.length / 2);
      const firstHalf = words.slice(0, midPoint).join(" ");
      const secondHalf = words.slice(midPoint).join(" ");
      return `${firstHalf}\n${secondHalf}`;
    }
    return title;
  };

  return (
    <StyledPageTitle>
      <div className="title-container">
        {onBack && (
          <BackButton onClick={onBack} aria-label="חזרה">
            <ChevronRight size={24} />
          </BackButton>
        )}
        <h1 className="title">{formatTitle(title)}</h1>
      </div>
      <img src={logo} alt="App Logo" className="logo" />
    </StyledPageTitle>
  );
};

export default PageTitle;
